import NumericEqualsFilterConverter from "./NumericEqualsFilterConverter.js";
import NumericNotEqualsFilterConverter from "./NumericNotEqualsFilterConverter.js";
import NumericBetweenFilterConverter from "./NumericBetweenFilterConverter.js";
import NumericGreaterThanFilterConverter from "./NumericGreaterThanFilterConverter.js";
import NumericLessThanFilterConverter from "./NumericLessThanFilterConverter.js";
import NumericLessThanOrEqualFilterConverter from "./NumericLessThanOrEqualFilterConverter.js";
import NumericGreaterThanOrEqualFilterConverter from "./NumericGreaterThanOrEqualFilterConverter.js";
import TimestampBetweenFilterConverter from "./TimestampBetweenFilterConverter.js";
import TimestampGreaterThanFilterConverter from "./TimestampGreaterThanFilterConverter.js";
import TimestampGreaterThanOrEqualFilterConverter from "./TimestampGreaterThanOrEqualFilterConverter.js";
import TimestampLessThanFilterConverter from "./TimestampLessThanFilterConverter.js";
import TimestampLessThanOrEqualFilterConverter from "./TimestampLessThanOrEqualFilterConverter.js";
export default {
  install(molten) {
    molten.addPlugin('ImagineComparatorFilterConverter', NumericEqualsFilterConverter);
    molten.addPlugin('ImagineComparatorFilterConverter', NumericNotEqualsFilterConverter);
    molten.addPlugin('ImagineComparatorFilterConverter', NumericBetweenFilterConverter);
    molten.addPlugin('ImagineComparatorFilterConverter', NumericGreaterThanFilterConverter);
    molten.addPlugin('ImagineComparatorFilterConverter', NumericGreaterThanOrEqualFilterConverter);
    molten.addPlugin('ImagineComparatorFilterConverter', NumericLessThanFilterConverter);
    molten.addPlugin('ImagineComparatorFilterConverter', NumericLessThanOrEqualFilterConverter);
    molten.addPlugin('ImagineComparatorFilterConverter', TimestampBetweenFilterConverter);
    molten.addPlugin('ImagineComparatorFilterConverter', TimestampGreaterThanFilterConverter);
    molten.addPlugin('ImagineComparatorFilterConverter', TimestampGreaterThanOrEqualFilterConverter);
    molten.addPlugin('ImagineComparatorFilterConverter', TimestampLessThanFilterConverter);
    molten.addPlugin('ImagineComparatorFilterConverter', TimestampLessThanOrEqualFilterConverter);
  }
};